import React, { Fragment } from 'react';
import GoogleIcon from '@tradera/blueprint/theme/icons-colored/google.svg?jsx';
import AppleIcon from '@tradera/blueprint/theme/icons2/network-apple.svg?jsx';
import FacebookIcon from '@tradera/blueprint/theme/icons/fb-square.svg?jsx';
import KlarnaIcon from '@tradera/blueprint/theme/icons-colored/klarna-k.svg?jsx';
import WarningIcon from '@tradera/blueprint/theme/icons/warning.svg?jsx';
import { useTranslator } from 'tradera/lang/translate';
import { PROVIDERS } from 'tradera/apps/registration/helpers/social-auth/providers';

const ProviderIcon = ({ providerType, className }) => {
    switch (providerType) {
        case PROVIDERS.GOOGLE:
            return <GoogleIcon className={className} />;
        case PROVIDERS.APPLE:
            return <AppleIcon className={className} />;
        case PROVIDERS.FACEBOOK:
            return <FacebookIcon className={className} />;
        case PROVIDERS.KLARNA:
            return <KlarnaIcon className={className} />;
        default:
            return <></>;
    }
};

const getProviderButtonClasses = (providerType) => {
    switch (providerType) {
        case PROVIDERS.GOOGLE:
            return 'btn-outline-dark google-register-button';
        case PROVIDERS.APPLE:
            return 'mb-2 btn-dark';
        case PROVIDERS.FACEBOOK:
            return 'mb-2 btn-facebook text-white';
        case PROVIDERS.KLARNA:
            return 'mb-2 btn-klarna';
        default:
            return '';
    }
};

export const SelectSocialSignup = ({ allSocialProviders, onSocialStart }) => {
    const { t } = useTranslator();

    return (
        <div className="text-center py-2">
            <div>
                {allSocialProviders.map((provider) =>
                    provider.customButton ? (
                        provider.customButton
                    ) : (
                        <Fragment key={provider.providerType}>
                            <button
                                className={`btn btn--icon-fixed btn-fluid position-relative mb-2 ${getProviderButtonClasses(
                                    provider.providerType
                                )}`}
                                aria-label={t(
                                    'registration_sign_up_with_provider',
                                    {
                                        providerName: provider.providerName
                                    }
                                )}
                                disabled={provider.getNotLoaded()}
                                onClick={onSocialStart(provider)}>
                                <ProviderIcon
                                    providerType={provider.providerType}
                                    className="icon icon-md icon-white icon-before"
                                />
                                {t('registration_sign_up_with_provider', {
                                    providerName: provider.providerName
                                })}
                            </button>

                            {provider.getNotLoaded() && (
                                <div className="alert alert-warning text-left d-flex">
                                    <WarningIcon className="icon flex-shrink-0 mr-4 align-baseline" />
                                    <span>
                                        {t(
                                            'registration_sign_up_with_provider_error',
                                            {
                                                providerName:
                                                    provider.providerName
                                            }
                                        )}
                                    </span>
                                </div>
                            )}
                        </Fragment>
                    )
                )}
            </div>
        </div>
    );
};
